<template>
  <div id="home-left" ref="appRef">
    <div class="host-body">
      <div class="host-body-left">
        <div class="top-box">
          <div class="wire"></div>
          <div class="left1">
            <div class="dataVF">
              <span class="box-title">
                {{ dateYear }} &nbsp;
                <span class="distance">融合学生人数</span>
              </span>
              <div class="student-num">{{ studentNum }}</div>
              <img src="@/assets/images/leftTime2.png" class />
              <div class="num-bottom">
                <span>10</span>
                <span>20</span>
                <span>30</span>
                <span>40</span>
                <span>50</span>
                <span>60</span>
                <span>70</span>
                <span>80</span>
                <span>90</span>
                <span>100</span>
              </div>
            </div>
            <div class="dataVF">
              <span class="box-title">本学年上报融合学生人数</span>
              <dv-digital-flop :config="studentNum2" />
            </div>
          </div>
        </div>
        <div class="center">
          <div class="center-left">
            <img src="@/assets/images/leftGirl.png" class="imgGirl" />
            <img src="@/assets/images/leftMan.png" class="imgMale" />
            <div class="sex-man-10">
              <div class="sex-girl-10" :style="{ width: girlRate + '%' }"></div>
            </div>

            <div class="leftA_one">
              <span class="box-title">{{ dateYear }}融合教育男女学生比例</span>
            </div>
            <leftChart2 :Ldata="Ldata" class="leftCenter"></leftChart2>
          </div>
          <div class="center-right">
            <div class="leftA_one">
              <span class="box-title">学生障碍类型占比</span>
            </div>
            <leftChart8
              class="leftCenterB_2"
              :RBdata="RBdata"
              v-if="RBdata.data"
            ></leftChart8>
          </div>
        </div>
        <div class="bottom">
          <div class="bottomLeft">
            <div class="bottomLeft_font">融合教育硬件设施增长统计</div>
            <div class="bottomLeft_A">
              <div class="bottomLeft_B_font green">{{ classroomCount }}</div>
              <div class="bottomLeft_B_fontSise">资源教室数量</div>
            </div>
            <div class="bottomLeft_B">
              <div class="bottomLeft_B_font yellow">{{ deviceCount }}</div>
              <div class="bottomLeft_B_fontSise">资源设备数量</div>
            </div>
          </div>
          <div class="bottomRight">
            <div class="bottomLeft_font">设施增加情况 {{ dateMonth }}</div>
            <div class="bottomRight_A">
              <label>增加</label>
              <span>{{ deviceCountAdd }}</span>
              台
            </div>
          </div>
        </div>
      </div>
      <div class="host-body-right">
        <!-- <div class="aRightA"> -->
        <div class="aRightTop">
          <div class="rightFont">学生障碍类型占比</div>
          <leftChart6
            :R1Adata="R1Adata"
            class="appA"
            v-if="R1Adata.yAxisData"
          ></leftChart6>
        </div>
        <div class="aRightBottom">
          <div class="rightFontSize">教师统计</div>
          <leftChart5 :LBdata="LBdata" class="bottomB_dataB_2"></leftChart5>
        </div>

        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import leftChart2 from '_c/echart/left/leftChart2.vue';
import leftChart3 from '_c/echart/left/leftChart3.vue';
import leftChart5 from '_c/echart/left/leftChart5.vue';
import leftChart6 from '_c/echart/left/leftChart6.vue';
// import leftChart7 from "_c/echart/left/leftChart7.vue";
import leftChart8 from '_c/echart/left/leftChart8.vue';
import { formatTime } from '@/utils/index.js';
import { getDataByUrl } from '@/api/index.js';

// * 千万不要删除注释掉的假数据！
// * 千万不要删除注释掉的假数据！
// * 千万不要删除注释掉的假数据！
export default {
  // mixins: [drawMixin],
  components: {
    leftChart2,
    leftChart3,
    leftChart5,
    leftChart6,
    // leftChart7,
    leftChart8
  },
  data() {
    return {
      studentNum: 0,
      studentNum2: {
        number: [0],
        content: '{nt}',
        style: {
          fontSize: 80,
          fill: '#fff'
        }
      },
      classroomCount: 0, // 资源教室数量
      deviceCount: 0, // 资源设备数量
      deviceCountAdd: 0, // 资源设备数量增加
      girlRate: 0,
      manRate: 0,
      Ldata: {
        data: [
          // { value: 0, name: "男",count:'0' },
          // { value: 0, name: "女",count:'0'  }
        ]
      },
      LBdata: {
        // data: [
        //   {
        //     name: '资源教师',
        //     value: 42
        //   },
        //   {
        //     name: '行政管理',
        //     value: 3
        //   },
        //   {
        //     name: '普通教师',
        //     value: 132
        //   }
        // ],
        // total: 177
      },
      R1Adata: {
        // legends: ['情绪障碍', '学习障碍', '智力障碍'],
        // xAxisData: ['学前', '小学 低年级', '初中', '其他'],
        // yAxisData: [
        //   {
        //     seriesName: '情绪障碍',
        //     seriesData: [2, 1, 3, 2]
        //   },
        //   {
        //     seriesName: '学习障碍',
        //     seriesData: [3, 2, 2, 4]
        //   },
        //   {
        //     seriesName: '智力障碍',
        //     seriesData: [1, 2, 3, 1]
        //   }
        // ]
      },
      RBdata: {
        // data: [
        //   { value: 10, name: '智力障碍' },
        //   { value: 20, name: '自闭症谱系障碍' },
        //   { value: 25, name: '言语沟通障碍' },
        //   { value: 55, name: '注意力/多动障碍' },
        //   { value: 9, name: '学习障碍' },
        //   { value: 22, name: '肢体障碍' },
        //   { value: 6, name: '视力障碍' },
        //   { value: 17, name: '听力障碍' },
        //   { value: 11, name: '脑瘫' },
        //   { value: 18, name: '病弱' }
        // ]
      },
      dateYear: null,
      dateMonth: null
    };
  },
  // mounted() {
  //   this.initData();
  // },
  created() {
    this.timeFn();
    this.initData();
  },
  methods: {
    /**
     * 初始化数据
     */
    initData() {
      this.getStudentNum(); // 融合学生人数
      this.getStudentDisability(); // 学生障碍类型占比（饼图）
      this.getDardwareNum();
      this.getStudentDisability2();
      this.getTeacherNum();
    },
    timeFn() {
      this.timing = setInterval(() => {
        this.dateYear = formatTime(new Date(), 'yyyy年M月');
        this.dateMonth = formatTime(new Date(), 'yyyy年');
      }, 1000);
    },
    //融合学生人数
    async getStudentNum() {
      getDataByUrl('student').then((res) => {
        if (res.code === '0') {
          let data = res.data;
          this.studentNum = data.maleTotalCount + data.femaleTotalCount;
          let yearTotalCount = data.maleYearCount + data.femaleYearCount;
          this.studentNum2 = {
            number: [yearTotalCount],
            content: '{nt}',
            style: {
              fontSize: 80,
              fill: '#fff'
            }
          };
          if (data.maleYearCount === 0 && data.femaleYearCount === 0) {
            return;
          }
          this.girlRate = parseInt(
            (data.femaleYearCount / yearTotalCount) * 100
          );
          this.manRate = 100 - this.girlRate;
          this.Ldata = {
            data: [
              { value: this.manRate, name: '男', count: data.maleYearCount },
              { value: this.girlRate, name: '女', count: data.femaleYearCount }
            ]
          };
        }
      });
    },

    //学生障碍类型占比（按类型，饼图）
    async getStudentDisability() {
      getDataByUrl('studentDisability').then((res) => {
        if (res.code === '0') {
          let data = res.data;
          this.RBdata = {
            data: data.map((item) => {
              return {
                value: item.count,
                name: item.type
              };
            })
          };
        }
      });
    },
    // 资源教室数量
    async getDardwareNum() {
      getDataByUrl('device').then((res) => {
        if (res.code === '0') {
          let data = res.data;
          this.classroomCount = data.classroomCount;
          this.deviceCount = data.deviceCount;
          this.deviceCountAdd = data.deviceCountAdd;
        }
      });
    },
    //学生障碍类型占比（分学段，柱状图）
    async getStudentDisability2() {
      getDataByUrl('studentDisability/section').then((res) => {
        if (res.code === '0') {
          let data = res.data;
          this.R1Adata = {
            legends: [],
            xAxisData: [],
            yAxisData: []
          };
          let legends = [];
          let xAxisData = [];
          let yAxisData = [];
          data.forEach((item) => {
            if (!legends.includes(item.type)) {
              legends.push(item.type);
            }
            if (!xAxisData.includes(item.time)) {
              xAxisData.push(item.time);
            }
          });
          legends.forEach((legend) => {
            let seriesData = [];
            xAxisData.forEach((xAxis) => {
              let count = 0;
              data.forEach((item) => {
                if (item.type === legend && item.time === xAxis) {
                  count = item.count;
                }
              });
              seriesData.push(count);
            });
            yAxisData.push({ seriesName: legend, seriesData: seriesData });
          });
          this.R1Adata = { legends, xAxisData, yAxisData };
        }
      });
    },
    // 教师统计
    async getTeacherNum() {
      getDataByUrl('teacher/type').then((res) => {
        if (res.code === '0') {
          let data = res.data;
          let dataArr = data.map((item) => {
            return {
              value: item.count,
              name: item.type
            };
          });
          let total = data.reduce((acc, cur) => {
            return acc + cur.count;
          }, 0);
          // this.$set(this, 'LBdata', {
          //   data: dataArr,
          //   total: total
          // });
          this.LBdata = {
            data: dataArr,
            total: total
          };
        }
      });
    },
    changeKeys(list) {
      list.forEach((elem) => {
        if (elem.type == 'total') {
          return;
        }
        elem.name = elem.type;
        elem.value = elem.count;
        delete elem.type;
        delete elem.count;
      });
      return list;
    },

    //学生障碍类型占比（分学段）
    async studentDisability() {
      // const { data } = await studentDisability();
      // console.log(data, '学生障碍类型占比（分学段）');
      this.R1Adata = {
        legends: ['情绪障碍', '学习障碍', '智力障碍'],
        xAxisData: ['学前', '小学 低年级', '初中', '其他'],
        yAxisData: [
          {
            seriesName: '情绪障碍',
            seriesData: [2, 1, 3, 2]
          },
          {
            seriesName: '学习障碍',
            seriesData: [3, 2, 2, 4]
          },
          {
            seriesName: '智力障碍',
            seriesData: [1, 2, 3, 1]
          }
        ]
      };

      // let newData = data.reduce((acc, cur) => {
      //   let obj = acc.find(
      //     (item) => item.time === cur.time && item.type === cur.type
      //   );
      //   if (obj) {
      //     obj.count += cur.count;
      //   } else {
      //     acc.push(cur);
      //   }
      //   return acc;
      // }, []);
      // newData.forEach((item) => {
      //   item.time = eduStageMap[item.time];
      //   return item;
      // });

      // let legends = [];
      // let xAxisData = [];
      // let yAxisData = [];

      // for (let i = 0; i < newData.length; i++) {
      //   if (!legends.includes(newData[i].type)) {
      //     legends.push(newData[i].type);
      //   }

      //   if (!xAxisData.includes(newData[i].time)) {
      //     xAxisData.push(newData[i].time);
      //   }
      // }

      // for (let i = 0; i < legends.length; i++) {
      //   let seriesData = [];
      //   for (let j = 0; j < xAxisData.length; j++) {
      //     let count = 0;
      //     for (let k = 0; k < newData.length; k++) {
      //       if (
      //         newData[k].type === legends[i] &&
      //         newData[k].time === xAxisData[j]
      //       ) {
      //         count = newData[k].count;
      //         break;
      //       }
      //     }
      //     seriesData.push(count);
      //   }
      //   yAxisData.push({ seriesName: legends[i], seriesData: seriesData });
      // }

      // this.R1Adata = {
      //   legends: legends,
      //   xAxisData: xAxisData,
      //   yAxisData: yAxisData
      // };
    }
  }
};
</script>

<style lang="scss" scoped>
#home-left {
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  color: #fff;

  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  // transform-origin: left top;
}
.host-body {
  display: flex;
  padding-left: 39px;
  padding-top: 86px;
  .host-body-left {
    position: relative;
    .top-box {
      width: 1157px;
      height: 280px;
      background: url('~@/assets/images/left-top-bg.png') no-repeat;
    }
  }
  .host-body-right {
    flex: 1;
    margin-left: 30px;
    position: relative;
  }
}
.left1 {
  position: absolute;
  left: 0;
  top: 0px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  padding-top: 55px;
  color: #2accff;
  // align-items: center;
}
.leftCenter {
  position: absolute;
  left: 0;
  top: 10px;
  width: 100%;
}

.imgGirl {
  width: 86px;
  height: 86px;
  position: absolute;
  left: 61px;
  top: 159px;
}
.imgMale {
  width: 86px;
  height: 86px;
  position: absolute;
  right: 64px;
  top: 159px;
}
.sex-man-10 {
  position: absolute;
  left: 157.5px;
  top: 293px;
  width: 25px * 10;
  height: 25px;
  background: url('~@/assets/images/leftMan2.png');
}
.sex-girl-10 {
  position: absolute;
  left: 0;
  top: 0px;
  width: 25%;
  height: 25px;
  background: url('~@/assets/images/leftGirl2.png');
  background-color: #0b2150;
}
.wire {
  position: absolute;
  top: 52px;
  left: 50%;
  width: 1px;
  height: 177px;
  border: 1px solid #4cccff;
}
.dataVF {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  .imgVF {
    padding-top: 50px;
  }
}
.distance {
  padding-left: 20px;
}
.num-bottom {
  margin-top: -30px;
  width: 310px;
  height: 30px;
  font-size: 19px;
  color: #246ee3;
  span {
    display: inline-block;
    margin-right: 8px;
  }
  span:nth-child(1) {
    transform: rotate(20deg) translateY(-15px);
  }
  span:nth-child(2) {
    transform: rotate(10deg) translateY(-8px);
  }
  span:nth-child(3) {
    transform: rotate(8deg) translateY(-3px);
  }
  span:nth-child(4) {
    transform: rotate(5deg) translateY(-1px);
  }
  span:nth-child(5) {
    transform: rotate(1deg) translateY(1px);
  }
  span:nth-child(6) {
    transform: rotate(-1deg) translateY(1px);
  }
  span:nth-child(7) {
    transform: rotate(-5deg) translateY(-1px);
  }
  span:nth-child(8) {
    transform: rotate(-8deg) translateY(-3px);
  }
  span:nth-child(9) {
    transform: rotate(-10deg) translateY(-6px);
  }
  span:nth-child(10) {
    transform: rotate(-20deg) translateY(-13px);
  }
}
.box-title {
  font-size: 26px;
  font-weight: 400;
  color: #17caf0;
}
.student-num {
  margin-top: 30px;
  margin-bottom: -25px;
  font-size: 65px;
  line-height: 65px;
  font-weight: 600;
  color: #09d5c6;
}
.box-title {
  font-size: 26px;
  font-weight: 400;
  color: #17caf0;
}

.center-left {
  width: 565px;
  height: 346px;
  margin-right: 13px;

  // 框.png
  background: url('~@/assets/images/background1.png') no-repeat;
  // background-color: antiquewhite;
  position: relative;
  // padding-right: 5px;
}
.center-right {
  width: 566px;
  height: 346px;
  margin-left: 13px;
  // 框.png
  background: url('~@/assets/images/background2.png') no-repeat;
}
.leftA_one {
  text-align: center;
  padding-top: 55px;
}

.leftA_B {
  width: 100%;
  position: relative;
  padding-left: 5px;
  .leftA_two_A {
    position: absolute;
    top: 40px;
    left: 0;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    width: 100%;
    text-align: center;
  }
  .leftA_two {
    margin-bottom: 20px;
    color: #2accff;
    width: 100%;
    height: 40px;
    // background-color: #09264a;
    // text-align: center;
    line-height: 40px;
  }
}

.center {
  display: flex;
}
.bottom {
  display: flex;
  margin-top: 12px;
  .bottomLeft {
    width: 564px;
    height: 336px;
    background: url('~@/assets/images/background3.png') no-repeat;
    margin-right: 13px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  .bottomRight {
    margin-left: 13px;
    width: 564px;
    height: 336px;
    background: url('~@/assets/images/background4.png') no-repeat;
    position: relative;
    div.bottomRight_A {
      margin-top: 50px;
      width: 100%;
      text-align: center;
      font-size: 30px;
      color: #fff;
      span {
        font-size: 100px;
        color: #51ef6b;
      }
    }
  }
  .bottomRightA {
    position: absolute;
    top: -20px;
    left: 0;
    width: 100%;
  }
}
.bottomLeft_A {
  width: 382px;
  height: 85px;
  background: url('~@/assets/images/background5.png') no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.bottomLeft_B {
  width: 382px;
  height: 85px;
  background: url('~@/assets/images/background6.png') no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.green {
  color: #51ef6b;
}
.yellow {
  color: #fecb00;
}
.bottomLeft_B_font {
  font-size: 24px;
  padding-bottom: 5px;
}
.bottomLeft_B_fontSise {
  font-size: 19px;
}
.bottomLeft_font {
  padding-top: 47px;
  color: #2accff;
  font-size: 25px;
  text-align: center;
}
.aRightTop {
  width: 666px;
  height: 478px;
  background: url('~@/assets/images/rightA.png') no-repeat;
  .appA {
    margin-top: 20px;
  }
}
.aRightBottom {
  margin-top: 18px;
  width: 666px;
  height: 478px;
  background: url('~@/assets/images/rightBottom.png') no-repeat;
}
.imgRightA {
  width: 100%;
  height: 480px;
  position: relative;
}
.rightA_1 {
  position: absolute;
  left: 0;
  top: 0;
  // width: ;
}
.imgRightB {
  width: 100%;
  position: relative;
}
.rightFont {
  padding-top: 52px;
  color: #2accff;
  font-size: 35px;
  width: 100%;
  text-align: center;
}
.rightFontSize {
  color: #2accff;
  font-size: 35px;
  padding-top: 52px;
  text-align: center;
}
</style>
